import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#80BA27',
            secondary: '#649120',
            success: '#80BA27',
            error: '#BA3314',
            info: '#9D9D9C',
            warning: '#E6D300',
          },
        },
      },
})
